import watch from 'redux-watch';

import { render } from './coreComponent';
import { generate } from '../../../core/js/utils/componentUtils';
import { dDom } from '../../../core/js/utils/renderUtils';

/**
 * This is a generic modal component.  To use you should pass in the following overrides
 *
 *  - template
 *
 *
 * optional, but useful
 * afterCloseAction - if you want
 */
export function init(store, overrides = {}) {
    const config = {
        firstRender: firstRender,
        name: 'modal.generic',
        renderType: dDom
    };

    return generate(config, store, overrides);
}

function firstRender(store) {
    this.render(store, this);
}

